<template>
  <header id="header" :style="headerStyle">
    <div class="logo f-l"><img :src="`${$store.state.imgUrl+$store.state.companyLogo}`"></div>
    <!--$store.state.companyLogo-->
    <div class="Top-title" @mousemove="subShow = false">{{$store.state.companyTitle}}</div>
    <div class="tabs-box f-l">
      <span :style="{'background-color': $store.state.headerActive==t?activeColor:''}" v-for="(tab,t) in tabData"
        @click="topClick(tab.path,t)" @mouseover="hoverHeader(t)" :class="{'active':$store.state.headerActive==t}"
        v-if="testFunc(tab.label)">{{tab.label}}
        <img :src="jt" v-if="t==0&&energyShow">
        </span>

      <transition name="el-zoom-in-top">
        <div v-show="subShow" class="subShow-box" @mouseleave="subShow=false">
          <div class="sub-box" @click="subClick(0)">默认首页</div>
          <div class="sub-box" @click="subClick(1)">能源管理</div>
        </div>
      </transition>
    </div>
    <div class="right">
      <!-- <div>官网</div>
            <div>服务与支持</div> -->
      <div style="height: 75px; position: absolute;right: 154px; width: 80px;"
        @mouseover="newsShow=false;detailsShow=false"> </div>
      <div class="tidings c-pointer" @mouseover="newsShow=false;detailsShow=false" @click="clickjy(1)"
        v-show="!$store.state.userConfig.mute"><img :src="jy"></div>
      <div class="tidings c-pointer" @mouseover="newsShow=false;detailsShow=false" @click="clickjy(0)"
        v-show="$store.state.userConfig.mute"><img :src="jy1"></div>
      <div class="tidings c-pointer" @mouseover="newsShow=true;detailsShow=false"
        @click="$router.push({path:'/CompanyConsole/Message'})">
        <img :src="tidings" v-show="!warning"/>
        <img :src="warningTidings" class="warning-tidings" v-show="warning"/>
        <img :src="red" v-show="regState()" class="top-red" />
        </div>
      <div class="mydata c-pointer" @mouseover="detailsShow=true;newsShow=false"
        @click="$router.push({path:'/CompanyConsole/userProfile'})"><img
          :src="`${$store.state.imgUrl+$store.state.userData.avatar}`" class="avatar" /> <img :src="look"
          v-show="$store.state.isLook" class="look"></div>
      <div @mouseover="newsShow=false;detailsShow=false"
        style="width: 15px; height: 75px; position: absolute; right: 0;"></div>
      <div @mouseover="newsShow=false;detailsShow=false"
        style="width: 225px; height: 5px; position: absolute; right: 0; top: 0;"></div>
    </div>
    <div class="user-box clearfix" v-show="detailsShow" @mouseleave="detailsShow=false">
      <p class="title"><span style="cursor: pointer;"
          @click="$router.push({path:'/CompanyConsole/userProfile'})">进入个人中心</span> <span class="see"
          v-show="!$store.state.isLook" @click="enterGuestMode">进入查看模式</span><span class="see"
          v-show="$store.state.isLook" @click="popup">退出查看模式</span></p>
      <div class="user-details">
        <p>用户信息</p>
        <p>账号：{{$store.state.userData.userName}}</p>
        <p>姓名：{{$store.state.userData.displayName}}</p>
        <p>组织：{{$store.state.userData.groupName}} </p>
        <p>公众号：{{$store.state.userData.wechatId=="" || $store.state.userData.wechatId== null ? '未绑定':'已绑定'}}</p>
      </div>
      <div class="btn-box">
        <el-button type="primary" class="btn" @click="logout">退出登录</el-button>
      </div>
      <span class="triangle"></span>
    </div>
    <div class="news-box clearfix" v-show="newsShow" @mouseleave="newsShow=false"
      @click="$router.push({path:'/CompanyConsole/Message'})">
      <p class="news-title">消息提示</p>
      <div class="scorll-box">
        <p v-for="(msg,m) in $store.state.messageList" :class="{'read':msg.state==1}">{{msg.context}}</p>
        <p v-if="$store.state.messageList.length==0">当前没有消息通知</p>
      </div>
      <p class="lookAll" @click="$router.push({path:'/CompanyConsole/Message'})">查看全部</p>
      <span class="triangle rigth-50"></span>
    </div>
    <!-- 弹窗 -->
    <div class="popup" v-show="popupShow">
      <div class="exit-guest">
        <div class="popup-title">
          验证身份<i class="el-icon-circle-close close" @click="close"></i>
        </div>
        <div class="popup-lab">
          <p>请输入密码：</p>
          <el-form :model="ruleForm" :rules="rules" ref="passForm" @submit.native.prevent>
            <el-form-item prop="password">
              <el-input v-model="ruleForm.password" show-password @keyup.enter.native="exitGuestMode"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <p class="btn-box">
          <el-button type="primary" @click="exitGuestMode">确定</el-button>
          <el-button @click="close">取消</el-button>
        </p>
      </div>
    </div>
  </header>
</template>
<script>
  export default {
    data() {
      return {
        logo: require("@/assets/image/header/logo.png"),
        jt: require("@/assets/image/energy/jt.png"),
        errorAudio: require('@/assets/video/error.wav'),
        remindAudio: require('@/assets/video/remind.mp3'),
        tidings: null,
        warningTidings: require('../../assets/image/header/warning-tidings.png'),
        red: require('../../assets/image/header/red.png'),
        look: require('../../assets/image/index/see.png'),
        jy: require('../../assets/image/header/jy.png'),
        jy1: require('../../assets/image/header/jy1.png'),
        detailsShow: false,
        popupShow: false,
        subShow: false,
        warning:false,
        ruleForm: {
          password: "",
        },
        rules: {
          password: [{
            required: true,
            message: "密码不能为空",
            trigger: 'blur'
          }]
        },
        tabData: [ //头部导航标签
          {
            label: "默认首页",
            path: this.$store.state.companyIndexPreviewUrl
          },
          {
            label: "设备管理",
            path: "/CompanyConsole/deviceList"
          },
          {
            label: "报警管理",
            path: "/CompanyConsole/DeviceAlarmList"
          },
          {
            label: "维保计划",
            path: "/CompanyConsole/ServicePlan"
          },
          {
            label: "计划任务",
            path: "/CompanyConsole/TaskPlan"
          },
          // {
          //   label: "首页编辑",
          //   path: "/CompanyConsole/IndexEdit"
          // },
          {
            label: "企业日志",
            path: "/CompanyConsole/CompanyLog"
          },
          {
            label: "数据分析",
            path: "/CompanyConsole/DataAnalytical"
          },
        ],
        active: 1,
        newsShow: false,
        state: 1,
        HTMLminWidth: 1560,
        massageLength:null,
        //用于更新样式
        headerStyle: {},
        headerStyleStore: {},
        activeColor: '#575f70', //选中的样式
        activeColorStore: '#575f70',
        mqttClient: false,
        audio: null, //报警播放器
        audio2: null, //提示播放器
        time: null, //定时器
        time2: null, //定时器
        sendArr:[],
        send:false,
        routerList:['/CompanyConsole/mapEditor','/CompanyConsole/mapEditorPreview','/CompanyConsole/DataAnalytical']
      }
    },
    created() {
      // console.log()
      if (this.$route.path == '/Energy/index'&&this.energyShow) {
        this.tabData[0] = {
          label: "能源管理",
          path: "/Energy/index"
        }
      }
      var afterUrl = window.location.href.split('?')[1];
      // console.log(afterUrl)
      if(afterUrl) {
      	/*如果是预览进入 则添加路由  .includes(this.$route.path)*/
      	this.routerList.push('/CompanyConsole/IndexEditShow')
      }
      this.tidings = require('@/assets/image/header/tidings' + this.cssType + '.png')
      if (this.$route.path == '/CompanyConsole/IndexEdit' || this.$route.path == '/CompanyConsole/newMould' || this.$store.state.userConfig.homepage == '/Energy/index') {
        this.HTMLminWidth = 1910
        this.$store.state.HTMLminWidth = 1910
        this.headerStyle = {};
        this.activeColor = '#575f70';
      } else if (this.$route.path == '/CompanyConsole/IndexEditShow' || this.$route.path.indexOf('/Energy') != -1) {
        this.HTMLminWidth = 1910
        this.$store.state.HTMLminWidth = 1910
      } else {
        this.HTMLminWidth = 1560
        this.$store.state.HTMLminWidth = 1560
        this.headerStyle = {};
        this.activeColor = '#575f70';
      }
      this.headerStyle['min-width'] = this.HTMLminWidth + 'px'
      if (this.$route.path == '/CompanyConsole/IndexEditShow') {
        this.$parent.headerBodyTop = -74
      }
      this.$forceUpdate()
      this.getDevice()
    },
    computed: {
      companyId() {
        return this.$store.state.companyId
      },
      broadcasting(){
        return this.$store.state.broadcasting
      },
      energyShow() {
        return this.$store.state.energyShow
      },
      mute(){
        return this.$store.state.userConfig.mute
      },
    },
    methods: {
      getDevice() {
        // 是否需要开启提示音
        if(this.routerList.includes(this.$route.path)){ return }
        let options = {
          clientId: this.$store.state.userData.code + '_'+ this.$store.state.companyCode+"_status_message",
          connectTimeout: 600000,
          clean: true
        }
        this.mqttClient = this.$mqtt.connect(this.$store.state.MQTT_SERVICE, options)
          let url = `sys/company/${this.companyId}/status/push`
          this.mqttClient.subscribe(url, {
            qos: 1
        })
        this.mqttClient.on('message', (topic, message) => {
          // console.log('getHold',topic,topic == url)
          if (topic == url){
            this.getHold()
          }
        })
      },
      // 获取存续数据
      getHold() {
        // console.log(this.$store.state.companyId)
        if(!this.$store.state.companyId){
          this.$store.state.companyId = Number(sessionStorage.getItem('companyId'));
        }
        this.get('/DeviceAlarm/countCompanyAlarmByType', {
          companyId: this.$store.state.companyId
        }).then(res => {
          // console.log(res.success && res.result[1].num && !this.broadcasting,res.success && !res.result[1].num,res)
          if (res.success && res.result[1].num && !this.broadcasting) {
            this.$store.state.broadcasting = true
            this.playError()
            this.warning = true
          } else if (res.success && !res.result[1].num) {
            this.$store.state.broadcasting = false
            this.warning = false
            if(this.audio){
              this.audio.pause()
            }
            if(this.time){
              clearInterval(this.time)
              this.time = null
            }
          }
        })
      },
      clickjy(v) {
        this.postNoJson('/UserConfig/set', {
          name: 'mute',
          value: v
        }).then(res => {
          if (res.success) {
            this.$store.state.userConfig.mute = v
            localStorage.setItem('mute',v)
            // 清楚定时器
            if(this.time){
              clearInterval(this.time)
              this.time = null
            }
            if(this.time2){
              clearTimeout(this.time2)
              this.time2 = null
            }
            // 当前开启声音，且audio对象存在时，停止
            if(v&&this.audio){
              this.$store.state.broadcasting = false
              this.audio.pause()
              this.audio = null
            }else if(!v){
              this.getHold()
            }
          } else {
            this.$message({
              type: 'warning',
              message: `设置失败: ${res.message}`
            });
          }
        })
      },
      // 播放报警
      playError() {
        if (this.time||this.mute) {
          return
        }
        if(this.audio){
          this.audio.pause()
        }
        this.audio = new Audio()
        this.audio.src = this.errorAudio
        this.audio.preload = 'auto'
        this.time = setInterval(() => {
          if(this.audio){
            if(this.mute){
              this.audio.pause()
            }else{
              this.audio.play()
            }
          }
        }, 1500)
      },
      // 播放提示
      playRemind() {
        // console.log('playRemind',this.broadcasting,this.mute,this.time2)
        if (this.broadcasting||this.mute||this.time2) {
          return
        }
        this.audio2 = new Audio()
        this.audio2.src = this.remindAudio
        this.audio2.preload = 'auto'
        this.audio2.play()
        this.time2 = setTimeout(() => {
          this.audio2.pause()
          clearTimeout(this.time2)
          this.time2 = null
        }, 15000)
      },
      // sub 点击事件
      subClick(i) {
        this.subShow = false
        let path = "/Energy/index"
        if (i) {
          this.tabData[0].label = '能源管理',
          this.tabData[0].path = '/Energy/index'
        } else {
          path = "/CompanyConsole/IndexEditShow"
          this.tabData[0].label = '默认首页',
          this.tabData[0].path = this.$store.state.companyIndexPreviewUrl
        }
        // console.log(this.$store.state.companyIndexPreviewUrl)
        this.$store.state.headerActive = 0
        // return  homepage
        let obj = { path:path }
        let data={
          name: "homepage",
          value: obj
        }
        this.postNoJson('/UserConfig/set', data).then((res) => {
          if (!res.success) {
            this.$message({
              type: 'warning',
              message: `配置首页路径失败：${res.message}`
            })
          } else {
            this.$store.state.userConfig.homepage = this.tabData[0].path
            localStorage.setItem('homepage',this.$store.state.userConfig.homepage)
          }
        })
        if(i){
          this.$router.push({
            path: this.$store.state.energyIndex
          });
        }else{
          this.$router.push({
            path: this.tabData[0].path
          });
        }
      },
      /*通过首页编辑 更新样式*/
      updateStyle(navItem, gradItem) {
        if (navItem.id == 3) return;
        if (navItem.id == 1) {
          if (navItem.background) {
            this.headerStyle['background-color'] = this.rgbaInit(navItem.background)
          }
        } else if (navItem.id == 2) {
          if (navItem.background && navItem.background2) {
            if (gradItem.id == 1) {
              /*径向渐变*/
              this.headerStyle['background-color'] = this.rgbaInit(navItem.background)
              this.headerStyle['background-image'] = 'radial-gradient(' + this.rgbaInit(navItem.background) + ' , ' +
                this.rgbaInit(navItem.background2) + ')'
            } else {
              /*角度渐变*/
              let deg = gradItem.deg || gradItem.deg == 0 ? gradItem.deg : 0
              this.headerStyle['background-color'] = this.rgbaInit(navItem.background)
              this.headerStyle['background-image'] = 'linear-gradient(' + deg + 'deg, ' + this.rgbaInit(navItem
                .background) + ' , ' + this.rgbaInit(navItem.background2) + ')'
            }
          }
        }
        this.activeColor = '#8686864d'
        this.activeColorStore = this.activeColor;
        this.headerStyleStore = this.headerStyle;
        this.$forceUpdate();
      },

      /*传入色板对象(字符串类型)  返回rgba(string)*/
      rgbaInit(str) {
        if (!str) return;
        let rgba = str;
        return 'rgba(' + rgba.r + ',' + rgba.g + ',' + rgba.b + ',' + rgba.a + ')'
      },

      // 导航tab hover事件
      hoverHeader(t) {
        this.newsShow = false
        this.detailsShow = false
        if (t == 0&&this.energyShow) {
          this.subShow = true
        } else {
          this.subShow = false
        }

      },

      //退出查看模式
      exitGuestMode() {
        this.$refs.passForm.validate((valid) => {
          if (valid) {
            let parm = {
              password: this.ruleForm.password
            };
            this.post('/UserProfile/exitGuestMode', parm).then((res) => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: `退出成功`
                });
                this.$store.state.isLook = false;
                this.$store.state.mask = false;
                this.popupShow = false;
                localStorage.setItem("isLook", false)
                this.$store.commit('changeLook', false);
                this.lookTime(localStorage.getItem('guestTime'))
                this.ruleForm.password = "";
              } else {
                this.$message({
                  type: 'warning',
                  message: `退出失败: ${res.message}`
                });
              }
            })
          }
        })

      },
      //进入查看模式
      enterGuestMode() {
        this.get('/UserProfile/enterGuestMode').then((res) => {
          if (res.success) {
            this.$store.state.isLook = true;
            localStorage.setItem('isLook', true)
            localStorage.removeItem('lastClickTime')
          }
        })
      },
      //退出登录
      logout() {
        this.get('/UserProfile/logout').then((res) => {
          if (res.success) {
            this.Destroy()
            localStorage.removeItem('userData')
            localStorage.removeItem("loginState")
            localStorage.removeItem('indexLoad')
            sessionStorage.removeItem('routerNext')
            this.$store.state.userData = null;
            this.$store.state.loginState = false;
            this.$store.state.broadcasting = false
            this.$router.push({
              path: this.cssType == 0 ? '/login' : '/TJCloudLogin'
            });
            localStorage.removeItem("isLook")
            localStorage.removeItem('lastClickTime')
          } else {
            this.$message({
              type: 'warning',
              message: '退出失败'
            });
          }
        })
      },
      //关闭弹窗
      close() {
        this.popupShow = false;
        this.$store.state.mask = false;
        this.password = "";
      },
      //显示弹窗
      popup() {
        this.detailsShow = false;
        this.popupShow = true;
        this.$store.state.mask = true;
      },
      topClick(path, i) {
        // console.log(this.$store.state.companyIndexPreviewUrl)
        if (path == '/CompanyConsole/DataAnalytical') {
          // let routerMyCard = this.$router.resolve({ path: path})
          // let reg = new RegExp('/dist')
          // routerMyCard.href = routerMyCard.href.replace(reg,"")
          // window.open( routerMyCard.href,path.split('/')[2]+this.$store.state.companyId)
          this.windowOpen('/CompanyConsole/DataAnalytical', path.split('/')[2] + this.$store.state.companyId,null,'数据分析 - '+document.title)
        } else {
          if(i==0&&this.tabData[0].path == '/Energy/index'){
            this.$router.push({
              path: this.$store.state.energyIndex
            });
          }else{
            this.$router.push({
              path: path
            });
          }
          this.$store.state.headerActive = i;
          //console.log(this.$route.path)
          if (this.$route.path == '/CompanyConsole/IndexEdit') {
            this.activeColor = '#575f70';
            this.headerStyle = {};
            this.HTMLminWidth = 1902
            this.$store.state.HTMLminWidth = 1902
          } else if (i==0) {
            this.headerStyle = this.headerStyleStore
            this.activeColor = this.activeColorStore
            this.HTMLminWidth = 1920
            this.$store.state.HTMLminWidth = 1920
          } else {
            this.activeColor = '#575f70';
            this.headerStyle = {};
            this.HTMLminWidth = 1560
            this.$store.state.HTMLminWidth = 1560
          }
          this.headerStyle['min-width'] = this.HTMLminWidth + 'px'
        }
        if (this.$route.path == '/CompanyConsole/IndexEditShow') {
          this.$parent.headerBodyTop = -74
          this.$parent.Resize();
        } else {
          this.$parent.headerBodyTop = 0
        }
      },
      // 验证权限
      testFunc(name) {
        if (name == '企业日志') {
          if (this.$store.state.functionList.includes('logCompany')) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      },
      // 消息状态
      regState() {
        let state = false,length=0
        for (let item of this.$store.state.messageList) {
          if (!state && item.state == 2) {
            state = true
          }
          if(item.state==2){
            length+=1
          }
        }
        if(length!=this.massageLength){
          this.massageLength = length
          this.playRemind()
        }
        return state
      },
      Destroy() {
        // from.meta.isBack = true;
        if(this.audio){
          this.audio.pause()
        }
        if(this.audio2){
          this.audio2.pause()
        }
        if(this.time){
          clearInterval(this.time)
          this.time = null
        }
        if(this.time2){
          clearTimeout(this.time2)
          this.time2 = null
        }
        this.$store.state.broadcasting = false
        if(this.mqttClient){
          for (let url of this.sendArr) {
            this.mqttClient.unsubscribe(url, () => {})
          }
        }
      },
    },

  }
</script>

<style scoped>
  .Top-title {
    float: left;
    height: 74px;
    line-height: 74px;
    font-size: 24px;
    font-weight: 700;
    color: #fff;
    margin-left: 20px;
    margin-right: 2%;
    max-width: 264px;
    box-sizing: border-box;
    user-select: none;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  #header {
    width: 100%;
    min-width: 1380px;
    height: 74px;
    background-color: #2f3a4e;
    position: relative;
  }

  #header .logo {
    max-width: 250px;
    min-width: 60px;
    height: 74px;
    margin-left: 30px;
    float: left;
    /*background-color: #2f3a4e;*/
  }

  .subShow-box {
    width: 110px;
    background-color: #2f3a4e;
    position: absolute;
    top: 74px;
    left: 0;
    z-index: 9999;
  }

  .logo img {
    height: 64px;
    line-height: 74px;
    margin-top: 5px;
    max-width: 135px;
  }

  #header .right {
    float: right;
    padding-right: 30px;
    box-sizing: border-box;
  }

  .right div {
    color: #fff;
    display: inline-block;
    font-size: 16px;
    line-height: 75px;
  }

  /* 	.right .tidings {
		margin: 0 60px;
	} */

  .right .tidings {
    position: relative;
    top: 10px;
    margin-right: 34px;
  }
  @keyframes blink {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .warning-tidings {
    animation: blink 1.5s infinite;
  }
  .right .mydata {
    position: relative;
    top: 15px;
  }

  .mydata .avatar {
    border-radius: 50%;
    width: 45px;
    height: 45px;
  }

  .right div:first-child {
    margin-right: 34px;
  }

  .right .top-red {
    position: absolute;
    top: 10px;
    left: 20px;
  }

  .user-box,
  .news-box {
    width: 432px;
    height: 340px;
    background-color: #fff;
    position: absolute;
    right: 14px;
    top: 86px;
    z-index: 9999;
    padding: 0 32px;
    box-sizing: border-box;
    text-align: left;
    box-shadow: 2px 2px 7px 2px rgb(0 0 0 / .2);
  }

  .title {
    line-height: 52px;
    font-size: 14px;
    color: #5087e4;
    border-bottom: 1px solid #dcdcdc;
    background-color: #fff;
  }

  .user-details {
    padding-top: 12px;
    background-color: #fff;
  }

  .user-details>p {
    line-height: 34px;
    font-size: 14px;
  }

  .btn-box {
    text-align: center;
    margin-top: 40px;
    background-color: #fff;
  }

  .details,
  .see {
    color: #5087e4;
    cursor: pointer;
  }

  .see {
    float: right;
    font-size: 14px;
  }

  .triangle {
    width: 0;
    height: 0;
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;
    border-bottom: 20px solid #fff;
    position: absolute;
    top: -20px;
    right: 28px;
  }

  .look {
    width: 20px;
    position: absolute;
    bottom: 25px;
    right: -5px;
  }

  /* 弹窗 */

  .popup>div {
    position: fixed;
    top: 188px;
    left: 50%;
    width: 498px;
    height: 308px;
    padding: 0 28px;
    box-sizing: border-box;
    margin-left: -249px;
    background-color: #fff;
    z-index: 1099 !important;
    padding-bottom: 30px;
  }

  .popup-title {
    font-size: 16px;
    line-height: 64px;
    border-bottom: 1px solid #e5e5e5;
    margin-bottom: 22px;
    text-align: left;
  }

  .popup-lab {
    text-align: left;
    font-size: 14px;
    line-height: 30px;
    margin-bottom: 14px !important;
    margin-top: 22px !important;
  }

  i.close {
    font-size: 20px;
    float: right;
    margin-top: 24px;
  }

  .btn-box {
    position: absolute;
    text-align: center;
    bottom: 36px;
    width: 100%;
    left: 0;
  }

  .btn-box .el-button {
    padding: 0 34px !important;
    line-height: 34px !important;
    margin: 0 20px;
  }

  .tabs-box {
    position: relative;
  }
  .tabs-box img{
    /* position: absolute;
    right: 8px;
    top:33px; */
    width: 12px;
    height: 8.2px;
    margin-left:4px;
  }
  .tabs-box span {
    display: inline-block;
    font-size: 16px;
    line-height: 74px;
    color: #fff;
    width: 110px;
    cursor: pointer;
    position: relative;
  }

  .tabs-box span:hover {
    background-color: #575f70;
  }

  .tabs-box span.active {
    background-color: #575f70;
  }

  .tabs-box span.active::after {
    content: "";
    display: block;
    height: 4px;
    background-color: #5087e4;
    position: absolute;
    bottom: 0;
    width: 100%;
  }

  .news-box {
    right: 66px !important;
  }

  .news-title {
    font-size: 16px;
    line-height: 46px;
  }

  .sub-box {
    line-height: 74px;
    color: #fff;
    font-size: 16px;
    text-align: center;
    background-color: #2f3a4e;
    cursor: pointer;
  }

  .sub-box:hover {
    background-color: #575f70;
  }

  .scorll-box p {
    line-height: 46px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 14px;
    border-bottom: 1px solid #dcdcdc;
  }

  .scorll-box>p:last-child {
    border: 0;
  }

  .scorll-box {
    height: 238px;
    overflow-y: auto;
    overflow-x: hidden;
    border-top: 1px solid #dcdcdc;
    border-bottom: 1px solid #dcdcdc;
  }

  .rigth-50 {
    right: 50px !important;
  }

  .lookAll {
    text-align: center;
    font-size: 14px;
    margin-top: 18px;
    cursor: pointer;
    color: #5087e4;
  }

  .read {
    color: #b1b1b1 !important;
  }
</style>
<style>
  .popup .el-input__inner {
    line-height: 34px !important;
    height: 34px !important;
    padding: 0 10px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/PublicAssembly/consoleHeader.vue